import { render, staticRenderFns } from "./Servermenu.vue?vue&type=template&id=6ad4a762&scoped=true"
import script from "./Servermenu.vue?vue&type=script&lang=js"
export * from "./Servermenu.vue?vue&type=script&lang=js"
import style0 from "./Servermenu.vue?vue&type=style&index=0&id=6ad4a762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4a762",
  null
  
)

export default component.exports